import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';

function AssetsListing() {
	return (
		<div className="flex flex-1 w-full items-center justify-between">
			<div className="flex items-center">
				<Typography
					component={motion.span}
					initial={{ x: -20 }}
					animate={{ x: 0, transition: { delay: 0.2 } }}
					delay={300}
					className="hidden sm:flex text-16 md:text-18 mx-12 font-semibold assets_catalog_header"
					// style = {{ color:'black',fontSize:'24px', fontWeight:'600',lineHeight:'32px'}}
				>
					 Assets Listing
				</Typography>				
			</div>
			
		</div>
	)
}
export default AssetsListing;
